$(document).ready(function() {
  if (window.location.pathname.includes('/collections/bass-baits/products/') || window.location.pathname.includes('/collections/walleye-baits/products/')) {
    // Redirect to 3.5"
    let searchParams = new URLSearchParams(window.location.search);
    if (window.location.pathname.includes('stinger') && !searchParams.has('variant')) {
      let variant_id = $('.swatch-group .swatch-element[data-value="3.5" - 15 Pack"]').data('vid');
      window.location.replace(window.location + '?variant=' + variant_id);
    }

    // Hide the 2.5"
    if ($('.swatch-group .swatch-element[data-value="3.5" - 15 Pack"]').length) {
      $('.swatch-group .swatch-element:not([data-value="3.5" - 15 Pack"])').hide();
    }
  }
});